import { handleMutationResult } from '@/helpers/toastHelper';
import { useUnpublishRosterMutation } from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { useCallback, useState } from 'react';
import { useRefreshRosters } from '../providers/RosterOptionsService';
import { useWorkingRoster, useWorkingRosterService } from '../providers/WorkingRosterService';

export const useUnpublishWorkingRoster = () => {
  const [{ error }, unpublish] = useUnpublishRosterMutation();
  const updateWorkingRoster = useWorkingRosterService(state => state.unpublishWorkingRoster);
  const { workingRoster } = useWorkingRoster();
  const refreshRosters = useRefreshRosters();

  // Same fetching workaround as usePublishWorkingRoster
  const [fetching, setFetching] = useState<boolean>(false);

  const unpublishRoster = useCallback(async () => {
    if (!workingRoster) {
      throw Error('Working roster should be defined');
    }
    setFetching(true);

    const result = await unpublish({
      rosterId: workingRoster.id
    });

    await handleMutationResult(result, {
      successMessage: strings.daily.roster.unpublishedSuccessMessage,
      errorMessage: strings.daily.roster.unpublishedFailureMessage,
      onSuccess: () => {
        updateWorkingRoster();
        refreshRosters();
      }
    });

    setFetching(false);

    return result;
  }, [unpublish, updateWorkingRoster, refreshRosters, workingRoster]);

  return { unpublishRoster, error, fetching };
};
